import {TabAtividades} from './Tab-Atividades'
import {TabAvaliacoes} from './Tab-Avaliacoes/Tab-Avaliacoes-Imovel'
import {TabCondicaoComercial} from './Tab-Condicao-Comercial'
import {TabContribuintes} from './Tab-Contribuintes'
import {TabCorretores} from './Tab-Corretores'
import {TabDocumentos} from './Tab-Documentos'
import {TabFichaTerritorial} from './Tab-Ficha-Territorial'
import {TabFotos} from './Tab-Fotos'
import {TabInformacoesLote} from './Tab-Informacoes-Lote'
import {TabObservacoes} from './Tab-Observacoes'
import {TabProprietarios} from './Tab-Proprietarios'
import {TabPainelMercado} from './Tab-Painel-Mercado'
import {TabProjetosAssociados} from './Tab-Projetos-Associados'
import {TabHistoricoTransacoes} from './Tab-Historico-Transacoes'
import {GetAcessoUsuarioProduto} from '../../../../utils/PermissoesAcesso'
import {MensagemBloqueio} from '../../../../components/Permissao/Index'

export function TabsImovelContainer({data, id, parameterUrl}) {
  const permissao = GetAcessoUsuarioProduto(28)

  const renderTab = () => {
    switch (parameterUrl) {
      case 'informacoes-lote':
        return <TabInformacoesLote param={parameterUrl} id={id} />
      case 'contribuintes':
        return <TabContribuintes param={parameterUrl} data={data} />
      case 'historico-transacoes':
        return permissao ? (
          <TabHistoricoTransacoes param={parameterUrl} data={data} />
        ) : (
          <MensagemBloqueio mensagem='Somente para assinantes.' />
        )
      case 'ficha-territorial':
        return <TabFichaTerritorial param={parameterUrl} data={data} />
      case 'observacoes':
        return <TabObservacoes param={parameterUrl} />
      case 'fotos':
        return <TabFotos param={parameterUrl} id={id} />
      case 'documentos':
        return <TabDocumentos param={parameterUrl} />
      case 'painel-mercado':
        return <TabPainelMercado param={parameterUrl} data={data} />
      case 'condicao-comercial':
        return <TabCondicaoComercial param={parameterUrl} />
      case 'corretores':
        return <TabCorretores param={parameterUrl} />
      case 'avaliacoes':
        return <TabAvaliacoes param={parameterUrl} data={data} />
      case 'proprietarios':
        return permissao ? (
          <TabProprietarios param={parameterUrl} data={data} />
        ) : (
          <MensagemBloqueio mensagem='Somente para assinantes do Produto .' />
        )
      case 'atividades':
        return <TabAtividades param={parameterUrl} />
      case 'projetos-associados':
        return <TabProjetosAssociados param={parameterUrl} />
      default:
        return null
    }
  }

  return (
    <div className='tab-content' id='tabContent'>
      {renderTab()}
    </div>
  )
}
